import React, { createContext, useContext } from 'react';

export interface IngestReadinessItem {
  documentId: string;
  versionId?: string | null;
  title?: string | null;
  lifecycleStage?: string | null;
}

interface IngestReadinessContextValue {
  items: IngestReadinessItem[];
  track: (_item: IngestReadinessItem) => void;
  untrack: (_documentId: string, _versionId?: string | null) => void;
}

const IngestReadinessContext = createContext<IngestReadinessContextValue>({
  items: [],
  track: () => undefined,
  untrack: () => undefined,
});

export function IngestReadinessProvider({ children }: { children: React.ReactNode }) {
  return (
    <IngestReadinessContext.Provider
      value={{
        items: [],
        track: () => undefined,
        untrack: () => undefined,
      }}
    >
      {children}
    </IngestReadinessContext.Provider>
  );
}

export function useIngestReadinessContext(): IngestReadinessContextValue {
  return useContext(IngestReadinessContext);
}
